export default "__VITE_ASSET__2d6ed66c__"